import React, { Component } from 'react';

export default class ResultTitle extends Component {
  render() {
    let {T} = this.props
    return (
      <div className="title-box">
          {!this.props.isError ? (<T.text tag="h1" text={"result-title.result-done"}/>) : (<T.text tag="h1" text={"result-title.result-error"}/>)}
          <p>{this.props.originalUrl}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/result/title.js